import * as ActionTypes from '../actions/Actiontype';

const initState = {
  error: '',
  getEmployer: { data: [] },
  singleEmployer: {},
};

const store = (state = initState, action) => {
  switch (action.type) {
    case ActionTypes.GET_EMPLOYER_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.GET_EMPLOYER_SUCCESS:
      return {
        ...state,
        getEmployer: action.payload,
      };
    case ActionTypes.GET_EMPLOYER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ActionTypes.ADD_EMPLOYER_INIT:
      return {
        ...state,
      };
    case ActionTypes.ADD_EMPLOYER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ActionTypes.ADD_EMPLOYER_SUCCESS:
      return {
        ...state,
        User: action?.payload?.data,
      };
    case ActionTypes.GET_SINGLE_EMPLOYER_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.GET_SINGLE_EMPLOYER_SUCCESS:
      return {
        ...state,
        singleEmployer: action?.payload,
      };
    case ActionTypes.GET_SINGLE_EMPLOYER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ActionTypes.SEARCH_EMPLOYER_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.SEARCH_EMPLOYER_SUCCESS:
      return {
        ...state,
        getEmployer: action?.payload,
      };
    case ActionTypes.SEARCH_EMPLOYER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default store;
